// extracted by mini-css-extract-plugin
export var layout = "Services-module--layout--0711e";
export var contentWrapper = "Services-module--contentWrapper--e903b";
export var subtitle = "Services-module--subtitle--e7f07";
export var column = "Services-module--column--a167a";